import React from "react";
import BrandComponent from "../../Masters/Brand/BrandComponents";

const SOQuotationIndexTable = () => {
  let header = [
    { label: "Id", field: "id" },
    { label: "Status", field: "status" },
    { label: "Quotation Type", field: "quotationtype" },
    { label: "Quotation Category", field: "quotationcategory" },
    { label: "Quotation No", field: "quotationno" },
    { label: "Quotation Date", field: "quotationdate" },
    { label: "Customer", field: "customercompanyname" },
    { label: "Quote Validity", field: "quotevalidity" },
  ];

  return (
    <BrandComponent
      header={header}
      tableTitle={"Quotation LIST"}
      apiField={"quotation"}
      addButton={"+ ADD"}
      createRoute={"/createQuotation"}
      updateRoute={"/viewQuotation"}
      viewRoute={"/viewQuotation"}
    />
  );
};

export default SOQuotationIndexTable;
